
import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

interface ShareRedFlagLinkProps {
  companyName: string;
}

const ShareRedFlagLink: React.FC<ShareRedFlagLinkProps> = ({ companyName }) => {
  const [copied, setCopied] = useState(false);
  
  const currentUrl = `${window.location.origin}/companies/${encodeURIComponent(companyName)}`;
  
  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setCopied(true);
    toast.success('Link copied to clipboard');
    
    // Reset copied state after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  
  return (
    <Card className="mb-8 border border-redflags-light/70">
      <CardContent className="pt-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-medium text-redflags-dark mb-2">
              Share this RedFlags profile
            </h3>
            <p className="text-redflags-gray">
              Help others by sharing this company profile:
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <a 
              href={currentUrl}
              className="font-medium text-redflags-red hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              RedFlags
            </a>
            
            <Button
              variant="outline"
              size="sm"
              onClick={handleCopyLink}
              className="flex items-center gap-1"
            >
              {copied ? (
                <>
                  Copied <Check className="h-4 w-4" />
                </>
              ) : (
                <>
                  Copy Link <Copy className="h-4 w-4" />
                </>
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ShareRedFlagLink;
